





























































import { getUserData } from "@/auth/getUserData";
import useTemplates from "@/composables/v3/useTemplates";
import { useChannelsStore } from "@/store/useChannelsStore";
import { useTemplatesStore } from "@/store/useTemplatesStore";
import { resolveMediaTemplateIcon } from "@/utils/templates";
import { RequestQueryBuilder } from "@rewiko/crud-request";
import { computed, defineComponent } from "@vue/composition-api";
import { BButton, BCardText, BListGroup, BListGroupItem, BOverlay, VBTooltip } from "bootstrap-vue";

export default defineComponent({
    components: {
        BListGroup,
        BListGroupItem,
        BCardText,
        BOverlay,
        BButton,
    },
    directives: {
        "b-tooltip": VBTooltip,
    },
    emits: ["manage-media-template"],
    setup() {
        const { setTemplate, templateSearchString } = useTemplates();

        const channelsStore = useChannelsStore();
        const templatesStore = useTemplatesStore();
        templatesStore.fetchTemplates(
            RequestQueryBuilder.create({
                join: { field: "channels", select: ["id"] },
                fields: ["title", "content", "components", "mediaType", "assetId", "assetIsLocked"],
                filter: [
                    { field: "channels.id", operator: "$eq", value: channelsStore.activeChatChannel?.id },
                    {
                        field: "status",
                        operator: "$eq",
                        value: "approved",
                    },
                ],
            })
        );

        const mediaTemplates = computed(() => {
            return templatesStore.mediaTemplates.filter((template) =>
                //lodash.startsWith(template.title.toLowerCase(), templateSearchString.value.toLowerCase())
                template.title.toLowerCase().includes(templateSearchString.value.toLowerCase())
            );
        });

        return {
            mediaTemplates,
            setTemplate,
            templatesStore,
            resolveMediaTemplateIcon,
            getUserData,
        };
    },
});
